<template>
  <tab-frame>
    <router-view></router-view>
  </tab-frame>
</template>

<script>
export default {
  name: 'channelTabs'
}
</script>
